import React, { useEffect, useState } from 'react';
import { DialogTitle, DialogContent, Dialog } from '@ublend-npm/aulaui-next';
import PropTypes from 'prop-types';
import { setAPIBlock } from '$utils/apiClient';
import StyledDialogActions from './ActiveDailogBox.styled';
import Button from '$components/Button';

const ActiveDialogBox = ({
  open,
  handleRegenerateSessionToken,
  handleSessionLogout,
}) => {
  const [loading, setLoading] = useState({ primary: false, secoundry: false });

  useEffect(() => {
    if (open) {
      setAPIBlock(true);
    } else {
      setAPIBlock(false);
    }
  }, [open]);

  const handleYesClick = async () => {
    setLoading({
      ...loading,
      primary: true,
    });
    setAPIBlock(false);
    await handleRegenerateSessionToken();
    setLoading({
      ...loading,
      primary: false,
    });
  };

  const handleNoClick = async () => {
    setLoading({
      ...loading,
      secoundry: true,
    });
    setAPIBlock(false);
    await handleSessionLogout();
    setLoading({
      ...loading,
      secoundry: false,
    });
  };

  const displayContent =
    "Please click 'Yes' to stay signed in. If you select 'No,' you will be logged out.";

  const displayTitle = 'Are you still using Aula?';
  return (
    <Dialog open={open} width="600" height="auto">
      <DialogTitle closeIcon={false}>{displayTitle}</DialogTitle>
      <DialogContent>{displayContent}</DialogContent>
      <StyledDialogActions>
        <Button
          label="No"
          onClick={handleNoClick}
          look="outlineDefault"
          loading={loading.secoundry}
          disabled={loading.primary}
        >
          No
        </Button>
        <Button
          label="Yes"
          onClick={handleYesClick}
          look="primary"
          loading={loading.primary}
          disabled={loading.secoundry}
        >
          Yes
        </Button>
      </StyledDialogActions>
    </Dialog>
  );
};

ActiveDialogBox.propTypes = {
  open: PropTypes.bool.isRequired,
  handleRegenerateSessionToken: PropTypes.func.isRequired,
  handleSessionLogout: PropTypes.func.isRequired,
};

export default ActiveDialogBox;
